var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBasedOnLogoBig({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 71.343,
    height: 54.427,
    viewBox: "0 0 71.343 54.427",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logoBig",
    transform: "translate(-559.411 -321.421)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    "data-name": "Rectangle 2",
    width: 14.465,
    height: 54.427,
    transform: "translate(559.411 321.421)",
    fill: "#0f0f0f"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4",
    "data-name": "Ellipse 4",
    cx: 12.136,
    cy: 12.136,
    r: 12.136,
    transform: "translate(577.553 323.137)",
    fill: "#0f0f0f"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_5",
    "data-name": "Ellipse 5",
    cx: 12.136,
    cy: 12.136,
    r: 12.136,
    transform: "translate(577.553 351.576)",
    fill: "#0f0f0f"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_6",
    "data-name": "Ellipse 6",
    cx: 12.136,
    cy: 12.136,
    r: 12.136,
    transform: "translate(606.482 351.576)",
    fill: "#0f0f0f"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasedOnLogoBig);
export default __webpack_public_path__ + "static/media/BasedOnLogoBig.cc161d552ee851d018887b401d370236.svg";
export { ForwardRef as ReactComponent };